(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adp-partner-schadeherstellers"] && !Shopify.designMode) return;
  try {
    
  const resetPartnerForm = (form) => {
    const button = form.querySelector('.adp-partner__form-submit');
    const status = form.querySelector('.adp-partner__submit-status');

    form.dataset.submitting = 'false';
    form.removeAttribute('aria-busy');

    if (button) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-label');
    }

    if (status) status.textContent = '';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.adp-partner__form');
    if (!form) return;

    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }

    if (!form.checkValidity()) return;

    const button = form.querySelector('.adp-partner__form-submit');
    const status = form.querySelector('.adp-partner__submit-status');
    const loadingLabel = button?.dataset.loadingLabel || 'Aanvraag wordt verstuurd…';

    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-label', loadingLabel);
    }

    if (status) status.textContent = loadingLabel;
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.adp-partner a[href*="-form-card"]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    const firstField = target?.querySelector('input:not([type="hidden"])');
    if (!firstField) return;

    window.setTimeout(() => firstField.focus({ preventScroll: true }), 450);
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.adp-partner__form').forEach(resetPartnerForm);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('vehicle-finder')) {
    customElements.define(
      'vehicle-finder',
      class VehicleFinder extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.plateInput = this.querySelector('[data-vehicle-plate]');
          this.lookupButton = this.querySelector('[data-vehicle-lookup]');
          this.status = this.querySelector('[data-vehicle-status]');
          this.searchInput = document.getElementById('Search-In-Template');
          this.searchForm = this.searchInput ? this.searchInput.closest('form') : null;
          this.requestedModel = new URLSearchParams(window.location.search).get('vehicle_model') || '';

          if (this.searchInput && this.searchForm && this.requestedModel) {
            this.searchInput.value = this.requestedModel;
            this.searchForm.addEventListener('submit', () => {
              if (this.normalize(this.searchInput.value) === this.normalize(this.requestedModel)) {
                this.searchInput.value = this.modelSearchQuery(this.requestedModel);
              }
            });
          }

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.lookupPlate();
          });
          this.plateInput.addEventListener('input', () => {
            this.plateInput.value = this.plateInput.value.toUpperCase();
          });
        }

        normalize(value) {
          return String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '');
        }

        searchBrand(brand) {
          const aliases = {
            mercedesbenz: 'Mercedes',
            mercedes: 'Mercedes',
            volkswagen: 'Volkswagen',
            citroen: 'Citroën',
            man: 'MAN',
          };
          const normalized = this.normalize(brand);
          if (aliases[normalized]) return aliases[normalized];
          return String(brand || '')
            .toLowerCase()
            .replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
        }

        vehicleModel(tradeName) {
          const normalizedTradeName = this.normalize(tradeName);
          const models = [
            ['Transit Custom', 'transitcustom'],
            ['Transit Connect', 'transitconnect'],
            ['Proace City', 'proacecity'],
            ['Crafter', 'crafter'],
            ['Transporter', 'transporter'],
            ['Caddy', 'caddy'],
            ['Sprinter', 'sprinter'],
            ['Vito', 'vito'],
            ['Citan', 'citan'],
            ['Master', 'master'],
            ['Trafic', 'trafic'],
            ['Kangoo', 'kangoo'],
            ['Movano', 'movano'],
            ['Vivaro', 'vivaro'],
            ['Combo', 'combo'],
            ['Boxer', 'boxer'],
            ['Expert', 'expert'],
            ['Partner', 'partner'],
            ['Jumper', 'jumper'],
            ['Jumpy', 'jumpy'],
            ['Berlingo', 'berlingo'],
            ['Ducato', 'ducato'],
            ['Scudo', 'scudo'],
            ['Doblo', 'doblo'],
            ['Transit', 'transit'],
            ['Daily', 'daily'],
            ['TGE', 'tge'],
            ['Proace', 'proace'],
            ['Dokker', 'dokker'],
            ['NV400', 'nv400'],
            ['NV300', 'nv300'],
            ['Interstar', 'interstar'],
            ['Primastar', 'primastar'],
          ];
          const match = models.find((model) => normalizedTradeName.includes(model[1]));
          if (match) return match[0];

          const ignored = /^(bluehdi|cdi|dci|hdi|multijet|tdi)$/i;
          const fallback = String(tradeName || '')
            .split(/\s+/)
            .find((part) => /[a-zÀ-ÿ]{3,}/i.test(part) && !ignored.test(part));
          if (!fallback) return '';
          return fallback.toLowerCase().replace(/(^|\s|-)[a-z]/g, (letter) => letter.toUpperCase());
        }

        modelSearchQuery(model) {
          const escapedModel = String(model).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          return `(title:"${escapedModel}" OR tag:"${escapedModel}")`;
        }

        setStatus(message, state = '') {
          this.status.textContent = message;
          this.status.dataset.state = state;
        }

        async lookupPlate() {
          const plate = this.plateInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          if (!/^[A-Z0-9]{6}$/.test(plate)) {
            this.setStatus(this.dataset.invalid, 'error');
            this.plateInput.focus();
            return;
          }

          this.lookupButton.setAttribute('aria-busy', 'true');
          this.lookupButton.disabled = true;
          this.setStatus('');

          try {
            const url = new URL(this.dataset.endpoint);
            url.searchParams.set('kenteken', plate);
            url.searchParams.set('$select', 'kenteken,merk,handelsbenaming,voertuigsoort');
            url.searchParams.set('$limit', '1');

            const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('RDW ' + response.status);

            const vehicles = await response.json();
            if (!vehicles.length) {
              this.setStatus(this.dataset.notFound, 'error');
              return;
            }

            const vehicle = vehicles[0];
            const brand = this.searchBrand(vehicle.merk);
            const model = this.vehicleModel(vehicle.handelsbenaming);

            if (!model) {
              this.setStatus(this.dataset.notFound, 'error');
              return;
            }

            if (this.searchInput) this.searchInput.value = model;
            this.setStatus(this.dataset.found + ' ' + [brand, model].filter(Boolean).join(' ') + '.');

            const params = new URLSearchParams();
            params.set('q', this.modelSearchQuery(model));
            params.set('vehicle_model', model);
            params.set('type', 'product');
            window.location.assign(this.dataset.searchUrl + '?' + params.toString());
          } catch (error) {
            this.setStatus(this.dataset.error, 'error');
          } finally {
            this.lookupButton.removeAttribute('aria-busy');
            this.lookupButton.disabled = false;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
